<template>
    <div class="page-user">
        <div class="top-title" v-if="contentReady"></div>
        <div class="container">
            <ContentLoader :isDisplay="!contentReady" />
            <div class="global-box-content box-content" v-if="contentReady">
                <div class="row">
                    <div class="d-lg-none col-md-12">
                        <div class="mobile-menu">
                            <button @click="openMobileMenu()">
                                {{ $PPlusEngine.getDictionary($route.params.lang, 'เลือกเมนู', 'Choose Menu') }}
                                <font-awesome-icon :icon="['fas', 'caret-down']" />
                            </button>
                            <div class="list" v-if="displayMenu">
                                <router-link :to="'/' + $route.params.lang + '/user/profile'" active-class="active"><i class="pe-7s-angle-right"></i> {{ $PPlusEngine.getDictionary($route.params.lang, 'ประวัติส่วนตัว', 'My Profile') }}</router-link>
                                <router-link :to="'/' + $route.params.lang + '/user/account'" active-class="active"><i class="pe-7s-angle-right"></i> {{ $PPlusEngine.getDictionary($route.params.lang, 'แก้ไขบัญชี', 'Account Setting') }}</router-link>
                                <router-link :to="'/' + $route.params.lang + '/user/certificate'" active-class="active"><i class="pe-7s-angle-right"></i> {{ $PPlusEngine.getDictionary($route.params.lang, 'ดาวน์โหลดใบรับรอง', 'Download Certificate') }}</router-link>
                                <button @click="logout()"><i class="pe-7s-angle-right"></i> {{ $PPlusEngine.getDictionary($route.params.lang, 'ออกจากระบบ', 'Logout') }}</button>
                            </div>
                        </div>
                    </div>
                    <div class="d-none d-lg-block col-md-12 col-lg-3">
                        <div class="side-menu">
                            <span class="pe-7s-user"></span>
                                <router-link :to="'/' + $route.params.lang + '/user/profile'" active-class="active"><i class="pe-7s-angle-right"></i> {{ $PPlusEngine.getDictionary($route.params.lang, 'ประวัติส่วนตัว', 'My Profile') }}</router-link>
                                <router-link :to="'/' + $route.params.lang + '/user/account'" active-class="active"><i class="pe-7s-angle-right"></i> {{ $PPlusEngine.getDictionary($route.params.lang, 'แก้ไขบัญชี', 'Account Setting') }}</router-link>
                                <router-link :to="'/' + $route.params.lang + '/user/certificate'" active-class="active"><i class="pe-7s-angle-right"></i> {{ $PPlusEngine.getDictionary($route.params.lang, 'ดาวน์โหลดใบรับรอง', 'Download Certificate') }}</router-link>
                            <button @click="logout()"><i class="pe-7s-angle-right"></i> {{ $PPlusEngine.getDictionary($route.params.lang, 'ออกจากระบบ', 'Logout') }}</button>
                        </div>
                    </div>
                    <div class="col-md-12 col-lg-9">
                        <div class="panel">
                            <slot name="content" />
                        </div>
                    </div>
                </div>         
            </div>
        </div>
    </div>
</template>

<script>
import ContentLoader from '@/weact/components/ContentLoader';

export default {
    components: { 
        ContentLoader
    },
    data() {
        return {
            contentReady: false,
            displayMenu: false
        }
    },
    created() {
        let page = this;
        
        setTimeout(function(){
            page.getContent();
        }, this.$WeConfig.TimeLoader);
    },
    methods: {
        openMobileMenu() {
            this.displayMenu = true;
        },
        logout() {
            this.$cookie.delete('token');
            location.reload();
        },
        getContent() {
            let apiURL = this.$PPlusConfig.ApiURL;
            let postData = {};

            this.$WeHelper.postAPI(apiURL, '/api/user/authen-user', postData, this.$PPlusEngine.getHeaderToken()).then((response) => {
                if (!this.$WeHelper.isNullOrEmpty(response.data)) {
                    if (response.data.user.isAuthen) {
                        this.contentReady = true;
                    }
                    else {
                        this.$router.push('/' + this.$route.params.lang + '/');
                    }
                }
                else {
                    this.$router.push('/' + this.$route.params.lang + '/404');
                }
            });
        }
    }
}
</script>

<style lang="scss">
@import '@/weact/scss/Variables.scss';

.page-user {
    position: relative;
    padding: 80px 0 40px;

    .top-title {
        position: absolute;
        z-index: 0;
        top: 0;
        left: 0;
        right: 0;
        background-image: url(../assets/user-bg.jpg);
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        height: 200px;
        margin-bottom: 40px;
    }

    .box-content {
        position: relative;
    }

    .mobile-menu {
        button {
            display: block;
            background: #f7f7f7;
            color: #333;
            width: 100%;
            font-size: 15px;
            position: relative;
            border: none;
            border-bottom: 3px solid #eee;
            padding: 15px;
            margin-bottom: 20px;
            outline: none;

            svg {
                position: absolute;
                right: 10px;
                top: 18px;
            }
        }
        
        .list {
            a, button {
                font-size: 14px;
                color: #333;
                display: block;
                padding: 10px 0;
                text-align: left;
                text-decoration: none;
                background: none;
                border: none;
                border-bottom: 1px solid #ddd;
                outline: none;

                i {
                    font-size: 18px;
                    vertical-align: middle;
                }
            }
        }
    }

    .side-menu {
        span {
            display: block;
            font-size: 120px;
            padding: 0 0 30px 20px;
            color: #ddd;
        }
        
        a, button {
            font-size: 16px;
            color: #aaa;
            display: block;
            padding: 0;
            padding-bottom: 20px;
            text-align: left;
            text-decoration: none;
            background: none;
            border: none;
            outline: none;

            i {
                font-size: 24px;
                vertical-align: middle;
            }

            &.active, &:hover {
                color: #000;
            }
        }
    }

    .panel {
        border-left: 1px solid #aaa;
        padding-left: 50px;

        @media only screen and (max-width: $screenMedium) {
            border-left: none;
            padding-left: 0;
        }

        label {
            font-size: 15px;
            color: #aaa;
        }

        .form-control[readonly] {
            background: #fff;
        }

        .action {
            padding-top: 10px;

            .btn {
                padding: 8px 18px;
            }
        }
    }
}
</style>